import { ListParamsType, MultipleActionsParams } from "go-list/list/services/types";
import { FILTER_SEPARATOR, NEW_WAY_TO_ENCODING_FILTER_SIGN } from "../../Filter/services";
import { ListSelectedFilter } from "../../Filter/services/types";

const getMultipleActionFParam = (params: ListParamsType): string | undefined => {
	if (params.f) return params.f;
	if (params.filters) {
		let fParamString = "";
		params.filters.forEach((filter) => {
			fParamString += `${FILTER_SEPARATOR}${filter.filterId}|${getFilterCondition(filter)}`;
		});
		return btoa(unescape(encodeURIComponent(NEW_WAY_TO_ENCODING_FILTER_SIGN + fParamString)));
	}
	return undefined;
};

export const getMultipleActionParams = (params: ListParamsType): MultipleActionsParams => {
	return {
		f: getMultipleActionFParam(params),
		search: params.search,
	};
};

const getFilterCondition = (filter: ListSelectedFilter) => {
	let filterCondition = `${filter.condition}`;

	if (
		filter.condition !== "false" &&
		filter.condition !== "true" &&
		filter.condition !== "u" &&
		filter.condition !== "a"
	) {
		filterCondition += `=${filter.value}`;
	}

	return filterCondition;
};
